/* eslint-disable @typescript-eslint/naming-convention */
import { createSelector, Selector } from "reselect";
import differenceInSeconds from "date-fns/differenceInSeconds";
import setSeconds from "date-fns/setSeconds";
import { PREFIX, TGlobalStateWithService } from "./const";
import { ECommState } from "../../types/redux";
import { IServiceState, IAppSettings, ISession } from "./namespace";

function selectServiceState(state: TGlobalStateWithService): IServiceState {
  return state[PREFIX];
}

export const selectVkState: Selector<
  TGlobalStateWithService,
  string | undefined
> = createSelector(selectServiceState, (state) => {
  return state.vkState;
});

export const selectSettings: Selector<
  TGlobalStateWithService,
  IAppSettings | undefined
> = createSelector(selectServiceState, (state) => {
  return state.settings;
});

export const selectSession: Selector<
  TGlobalStateWithService,
  ISession | undefined
> = createSelector(selectServiceState, (state) => {
  return state.session;
});

export const selectCheckSession: Selector<
  TGlobalStateWithService,
  boolean | undefined
> = createSelector(selectServiceState, (state) => {
  return Boolean(state.session.access_token);
});

export const selectRefreshTokenPending: Selector<
  TGlobalStateWithService,
  boolean
> = createSelector(selectServiceState, (state) => {
  return state.communication.refreshToken.state === ECommState.pending;
});

export const selectVersionValid: Selector<
  TGlobalStateWithService,
  boolean
> = createSelector(selectServiceState, (state) => {
  return state.communication.vkAppVersion.state === ECommState.fulfilled;
});

export const selectCheckSessionExpiration: Selector<
  TGlobalStateWithService,
  number | undefined
> = createSelector(selectServiceState, (state) => {
  const {
    access_token,
    access_token_expiration_time,
    access_token_datetime,
  } = state.session;

  if (!access_token) return 0;

  const currentDateTime = new Date();
  const accessDateTime = new Date(access_token_datetime);
  const expirationDateTime = setSeconds(
    accessDateTime,
    Number(access_token_expiration_time)
  );
  const secondsLeft = differenceInSeconds(currentDateTime, expirationDateTime);
  return secondsLeft;
});
